module.exports = __webpack_public_path__ + "static/media/antel.832d9c6a.svg";